import {
  TOGGLE_COLLABORATE_WIDGET,
  BULK_CHANGE_COLLAB_STATE_ROUTINE,
  CHANGE_COLLAB_STATE_ROUTINE,
  HANDLE_STATUS_CHANGED,
  INIT_EXTERNAL_COLLAB_ROUTINE,
  ADD_EXTERNAL_COLLAB_THEME_ROUTINE,
  UPDATE_EXTERNAL_COLLAB_THEME_ROUTINE,
  DELETE_EXTERNAL_COLLAB_THEME_ROUTINE,
  ADD_EXTERNAL_COLLAB_LINK_ROUTINE,
  UPDATE_EXTERNAL_COLLAB_LINK_ROUTINE,
  DELETE_EXTERNAL_COLLAB_LINK_ROUTINE,
  GET_COLLABORATION_COMMENTS_ROUTINE,
  GET_COLLABORATION_USERS_ROUTINE,
  GET_COLLABORATION_UNREADS_COUNT_ROUTINE,
  MARK_COLLABORATION_CHANNEL_AS_READ,
  ADD_COLLABORATION_COMMENT_ROUTINE,
  EDIT_COLLABORATION_COMMENT_ROUTINE,
  DELETE_COLLABORATION_COMMENT_ROUTINE,
  NEW_COLLABORATION_COMMENT_RECEIVED,
  COLLABORATION_COMMENT_EDITED,
  NEW_UNREAD_NOTIFICATION_RECEIVED,
  CLEAN_STORE_COMMENTS,
} from "constants/ActionTypes";
import { createAction } from "@reduxjs/toolkit";
import {
  ColComment,
  ColCommentMetadata,
  ColCommentVisibility,
  ColTheme,
} from "../components/Collaboration/types";

export const toggleCollaborateWidget = (index: number, post: unknown) => ({
  type: TOGGLE_COLLABORATE_WIDGET,
  index,
  post,
});

export const bulkChangeCollabState = createAction(
  BULK_CHANGE_COLLAB_STATE_ROUTINE.TRIGGER,
  function prepare(postIds: string[], postType: string, key: string) {
    return {
      payload: {
        postIds,
        postType,
        key,
      },
    };
  }
);

export const changeCollabState = createAction(
  CHANGE_COLLAB_STATE_ROUTINE.TRIGGER,
  function prepare(
    postIds: string[],
    postType: string,
    key: string,
    callback: (ap?: string) => void
  ) {
    return {
      payload: {
        postIds,
        postType,
        key,
        callback,
      },
    };
  }
);

export const initExternalCollab = createAction(
  INIT_EXTERNAL_COLLAB_ROUTINE.TRIGGER
);
export const addExternalCollabTheme = createAction(
  ADD_EXTERNAL_COLLAB_THEME_ROUTINE.TRIGGER,
  function prepare(theme: ColTheme) {
    return {
      payload: {
        theme,
      },
    };
  }
);
export const updateExternalCollabTheme = createAction(
  UPDATE_EXTERNAL_COLLAB_THEME_ROUTINE.TRIGGER,
  function prepare(theme: ColTheme) {
    return {
      payload: {
        theme,
      },
    };
  }
);
export const deleteExternalCollabTheme = createAction(
  DELETE_EXTERNAL_COLLAB_THEME_ROUTINE.TRIGGER,
  function prepare(id: string) {
    return {
      payload: {
        id,
      },
    };
  }
);
export const addExternalCollabLink = createAction(
  ADD_EXTERNAL_COLLAB_LINK_ROUTINE.TRIGGER,
  function prepare(link: string) {
    return {
      payload: {
        link,
      },
    };
  }
);
export const updateExternalCollabLink = createAction(
  UPDATE_EXTERNAL_COLLAB_LINK_ROUTINE.TRIGGER,
  function prepare(link: string) {
    return {
      payload: {
        link,
      },
    };
  }
);
export const deleteExternalCollabLink = createAction(
  DELETE_EXTERNAL_COLLAB_LINK_ROUTINE.TRIGGER,
  function prepare(id: string) {
    return {
      payload: {
        id,
      },
    };
  }
);

export const getCollaborationComments = createAction(
  GET_COLLABORATION_COMMENTS_ROUTINE.TRIGGER,
  function prepare(channelId: string) {
    return {
      payload: {
        channelId,
      },
    };
  }
);

export const getCollaborationUsers = createAction(
  GET_COLLABORATION_USERS_ROUTINE.TRIGGER,
  function prepare() {
    return {
      payload: {},
    };
  }
);

export const getCollaborationUnreadsCount = createAction(
  GET_COLLABORATION_UNREADS_COUNT_ROUTINE.TRIGGER,
  function prepare() {
    return {
      payload: {},
    };
  }
);

export const markCollaborationChannelAsRead = createAction(
  MARK_COLLABORATION_CHANNEL_AS_READ,
  function prepare(channelId: string) {
    return {
      payload: { channelId },
    };
  }
);

export const addCollaborationComment = createAction(
  ADD_COLLABORATION_COMMENT_ROUTINE.TRIGGER,
  function prepare(
    channelId: string,
    body: string,
    metadata: ColCommentMetadata,
    visibility: ColCommentVisibility,
    done: () => void,
    onError?: (err: unknown) => void
  ) {
    return {
      payload: { channelId, body, metadata, visibility, done, onError },
    };
  }
);

export const editCollaborationComment = createAction(
  EDIT_COLLABORATION_COMMENT_ROUTINE.TRIGGER,
  function prepare(
    channelId: string,
    commentId: string,
    body: string,
    visibility: ColCommentVisibility,
    done: () => void,
    onError?: (err: unknown) => void
  ) {
    return {
      payload: { channelId, commentId, body, visibility, done, onError },
    };
  }
);

export const deleteCollaborationComment = createAction(
  DELETE_COLLABORATION_COMMENT_ROUTINE.TRIGGER,
  function prepare(channelId: string, commentId: string, done: () => void) {
    return {
      payload: { channelId, commentId, done },
    };
  }
);

export const newCollaborationCommentReceived = createAction(
  NEW_COLLABORATION_COMMENT_RECEIVED,
  function prepare(comment: ColComment, userId: string, channelId: string) {
    return {
      payload: { comment, userId, channelId },
    };
  }
);

export const collaborationCommentEdited = createAction(
  COLLABORATION_COMMENT_EDITED,
  function prepare(comment: ColComment, channelId: string) {
    return {
      payload: { comment, channelId },
    };
  }
);

export const newUnreadNotificationReceived = createAction(
  NEW_UNREAD_NOTIFICATION_RECEIVED.TRIGGER,
  function prepare(channelId: string) {
    return {
      payload: { channelId },
    };
  }
);

export const handleStatusChanged = createAction(
  HANDLE_STATUS_CHANGED,
  function prepare(postType: string, post: unknown) {
    return {
      payload: { postType, post },
    };
  }
);

export const cleanStoreComments = createAction(
  CLEAN_STORE_COMMENTS,
  function prepare(channelId: string) {
    return {
      payload: { channelId },
    };
  }
);
